import setNotificationSettingsService from 'owa-service/lib/operation/setNotificationSettingsOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import notificationSettingsRequest from 'owa-service/lib/factory/notificationSettingsRequest';
export default function setNotificationSettings(newMailSettings, enableReminders, enableReminderSound) {
    return setNotificationSettingsService({
        Header: getJsonRequestHeader(),
        Body: notificationSettingsRequest({
            NewItemNotify: newMailSettings,
            EnableReminders: enableReminders,
            EnableReminderSound: enableReminderSound,
        }),
    });
}
//# sourceMappingURL=setNotificationSettings.js.map